import React, { useContext, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import firebase from 'gatsby-plugin-firebase';

import { FirebaseContext } from '../../context/FirebaseContext';
import Heart from '../../images/icons/heart.inline.svg';
import { TransitionMixin, media } from '../helpers';

const WishlistButtonContainer = styled.div`
    button {
        color: #000;
        background-color: #f2f0eb;
        font-weight: normal;
        border: 1px solid #f2f0eb;
        border-radius: 5px;
        padding: 16px 0;
        width: 100%;
        max-width: 210px;
        ${media.medium`padding: 21px 0;`}

        &.active {
            svg {
                fill: #f74d33;
            }
        }

        svg {
            height: 18px;
            width: 18px;
            margin-left: 5px;
            position: relative;
            top: 3px;
            stroke: #f74d33;
            ${TransitionMixin('.25s')}
        }
    }
    .response {
        opacity: 0;
        transform: translate3d(0, -10px, 0);
        position: absolute;
        ${TransitionMixin('.25s')};
        &.active {
            opacity: 1;
            transform: translate3d(0, 0px, 0);
        }
        p {
            text-align: center;
            /* padding-top: 5px; */
            font-size: 14px;
            color: #f74d33;
            font-weight: bold;
            margin: 0;
        }
    }
`;

const WishlistButton = ({ currentVariant, handle }) => {
    const [response, setResponse] = useState('');
    const [wishlistText, setWishlistText] = useState('Add to wishlist');

    const { user } = useContext(FirebaseContext);

    const responseRef = useRef(null);
    const wishlistBtnRef = useRef(null);

    function addProductToWishList(userId, handle) {
        let wishlistRef = firebase
            .database()
            .ref('users/' + userId + '/wishlist');

        console.log(wishlistRef);
        wishlistRef
            .push({
                handle: handle,
                variant: currentVariant,
            })
            .then((res) => toggleResponse('Added!'))
            .catch((error) => toggleResponse('There was an issue'));
    }

    function toggleResponse(message) {
        setResponse(message);
        wishlistBtnRef.current.classList.add('active');
        responseRef.current.classList.add('active');
        setWishlistText('Added to wishlist');
        setTimeout(() => {
            responseRef.current.classList.remove('active');
        }, 4000);
    }

    function toggleWishlist(userId, handle) {}

    useEffect(() => {
        console.log(user);
        if (user) {
            firebase
                .database()
                .ref('users/' + user.id + '/wishlist')
                .on('value', function (snapshot) {
                    if (snapshot.val() !== null) {
                        const arrayOfObj = [];
                        Object.entries(snapshot.val()).map((e) => {
                            let wishlistItem = {
                                id: e[0],
                                product: {
                                    handle: e[1].handle,
                                    variant: e[1].variant,
                                },
                            };
                            arrayOfObj.push(wishlistItem);
                        });
                        console.log(currentVariant);

                        let isCurrentItemOnWishlist =
                            currentVariant &&
                            arrayOfObj.filter(
                                (item) =>
                                    item.product.handle === handle &&
                                    item.product.variant.shopifyId ===
                                        currentVariant.id
                            );
                        console.log(isCurrentItemOnWishlist);

                        // setUserWishListItems(arrayOfObj);
                    } else {
                        // setUserWishListItems([]);
                    }
                });
        }
    }, [user, currentVariant]);
    return (
        <WishlistButtonContainer>
            {user && (
                <div className="btn-container desktop addtowishlist">
                    <button
                        ref={wishlistBtnRef}
                        onClick={() => addProductToWishList(user.id, handle)}
                    >
                        {wishlistText}{' '}
                        <span>
                            <Heart />
                        </span>
                    </button>

                    <div ref={responseRef} className="response">
                        <p>{response}</p>
                    </div>
                </div>
            )}
        </WishlistButtonContainer>
    );
};

export default WishlistButton;
